var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLanguageDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2M12 22C9.58375 22 7.625 17.5228 7.625 12C7.625 6.47715 9.58375 2 12 2M12 22C14.4162 22 16.375 17.5228 16.375 12C16.375 6.47715 14.4162 2 12 2M3.875 16.8605C5.70703 15.8114 8.55485 15 12 15C15.5956 15 18.9501 15.8727 20.75 17M3.875 7.13954C5.70703 8.18861 8.55485 9 12 9C15.5956 9 18.9501 8.12734 20.75 7",
    stroke: "black",
    strokeWidth: 1.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguageDark);
export default __webpack_public_path__ + "static/media/LanguageDark.b5d4274a2591cab571225268c2dcac79.svg";
export { ForwardRef as ReactComponent };